import {
	CompoundButton,
	Dialog,
	DialogFooter,
	DialogType,
	Label,
	Spinner,
} from '@fluentui/react';
import { observer } from 'mobx-react';
import { IRootStateProps } from '../../state/RootState';

const modelProps = {
	isBlocking: false,
	styles: { main: { maxWidth: 450 } },
};

const dialogContentProps = {
	type: DialogType.normal,
	title: 'Permission required',
	subText: `To view your SharePoint content, this application requires your permission.`,
};

/**
 * Renders a button which, when selected, will open a popup for login
 */
export const GrantSPPermissions = observer((state: IRootStateProps) => {
	if (!state.RootState.spAuth.spAuthRequired) {
		return <div>Shouldn't get here</div>;
	}

	if (state.RootState.spAuth.spAuthInProgress) {
		return (
			<Spinner label="Connecting you to SharePoint for the first time. This can take a few minutes. Please wait..." />
		);
	} else {
		return (
			<Dialog
				dialogContentProps={dialogContentProps}
				modalProps={modelProps}
				hidden={false}
				onDismiss={() => {
					state.RootState.spAuth.cancelAuth();
				}}
			>
				<Label>Click consent to continue.</Label>
				<DialogFooter>
					<ConsentButton RootState={state.RootState}></ConsentButton>
				</DialogFooter>
			</Dialog>
		);
	}
});

export const ConsentButton = observer((state: IRootStateProps) => {
	return (
		<CompoundButton
			secondaryText="This will allow access to SharePoint."
			style={{ marginTop: 8 }}
			iconProps={{ iconName: 'Permissions' }}
			onClick={() => {
				authenticate(state.RootState.spAuth.authWebUrl).then(
					() => {
						state.RootState.spAuth.waitForSharePointPermissions();
					},
					() => {
						//reject
						console.log('Auth reject');
					},
				);
			}}
		>
			Grant consent
		</CompoundButton>
	);
});

let authenticate = function (webUrl: string) {
	return new Promise<void>((resolve, reject) => {
		let x = 100,
			y = 100;
		let width = 600,
			height = 800;

		if (window.top) {
			y = window.top.outerHeight / 2 + window.top.screenY - height / 2;
			x = window.top.outerWidth / 2 + window.top.screenX - width / 2;
		}

		let win = window.open(
			'/#authStart/' + encodeURIComponent(webUrl),
			'Authenticate',
			`width=${width},height=${height},top=${y},left=${x}`,
		);
		let interval = setInterval(() => {
			if (!win || win.closed) {
				clearInterval(interval);
				resolve();
			} else {
				try {
					if (
						win.location.hash === '#authComplete' ||
						(win.location.hash || '').startsWith('#code=') ||
						(win.location.hash || '').startsWith('#id_token=')
					) {
						win.close();
						clearInterval(interval);
						resolve();
					}
				} catch {
					// The window may be currently at microsoftonline.com and a cross-origin location check won't work.
				}
			}
		}, 100);
	});
};
